// ===========================================
// Enquiry Detail Drawer Component
// ===========================================
// The slide-in shell around the enquiry panel (`enquiries/EnquiryPanel.tsx`, enquiries plan §7):
// the panel holds the content, in the brief's order. Opening one changes nothing: every write is
// a button.

import { Drawer } from '@mui/material';
import EnquiryPanel from './enquiries/EnquiryPanel';

interface EnquiryDetailDrawerProps {
  enquiryId: string | null;
  open: boolean;
  onClose: () => void;
}

export default function EnquiryDetailDrawer({ enquiryId, open, onClose }: EnquiryDetailDrawerProps) {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: { width: { xs: '100%', sm: 560 }, display: 'flex', flexDirection: 'column' },
      }}
    >
      {enquiryId && <EnquiryPanel enquiryId={enquiryId} onClose={onClose} />}
    </Drawer>
  );
}
